export default {
  export: 'export',
  create: 'create',
  select: 'select',
  items: 'items',
  contractName: 'Name',
  contractStatus: 'Status',
  contractNum: 'Number',
  contractType: 'Type',
  contractPayType: 'Pay Type',
  contractAmount: 'Amount',
  operation: 'Operation',
  detail: 'detail',
  delete: 'delete',
  pay: 'pay',
  receive: 'received',
  placeholder: 'please enter to search',
  contractStatusEnum: {
    fail: 'fail',
    audit: 'audit',
    executing: 'executing',
    pending: 'pending',
    finish: 'finish',
  },
};
